import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { Seo } from "@/components/Seo";
import { GUIDE_ORDER, GUIDE_ARTICLES } from "@/lib/guideData";

export default function GuideIndex() {
  return (
    <>
      <Seo
        title="Guide cybersécurité et informatique pour TPE"
        description="Des explications simples sur la cybersécurité et l'informatique des petites entreprises : mots de passe, wifi visiteurs, sauvegardes, rançongiciels, et plus encore."
        path="/guide"
      />

      <section className="bg-navy grain relative pt-40 pb-20 md:pt-48 md:pb-24 overflow-hidden">
        <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] font-medium text-amber-500">Le guide</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="mt-5 font-display text-5xl sm:text-6xl md:text-7xl font-bold tracking-tighter text-white text-balance">
              Comprendre, sans jargon.
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg md:text-xl text-slate-300 max-w-xl leading-relaxed">
              Des explications simples sur les sujets qui reviennent le plus souvent, pour
              comprendre pourquoi chaque protection compte réellement.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 space-y-px">
          {GUIDE_ORDER.map((slug, i) => {
            const article = GUIDE_ARTICLES[slug];
            if (!article) return null;
            return (
              <Reveal key={slug} delay={i * 0.05}>
                <Link
                  to={`/guide/${slug}`}
                  className="group flex items-center justify-between gap-6 py-8 border-t border-slate-200 last:border-b hover:bg-slate-50 -mx-5 px-5 sm:-mx-8 sm:px-8 transition-colors"
                  data-testid={`guide-index-link-${slug}`}
                >
                  <div>
                    <span className="text-xs uppercase tracking-[0.25em] font-medium text-amber-600">{article.eyebrow}</span>
                    <h2 className="mt-2 font-display text-xl sm:text-2xl font-semibold tracking-tight text-navy">{article.title}</h2>
                    <p className="mt-2 text-slate-600 leading-relaxed max-w-2xl">{article.shortAnswer}</p>
                  </div>
                  <ArrowRight className="w-6 h-6 text-slate-300 group-hover:text-amber-500 group-hover:translate-x-1 transition-all shrink-0" />
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>
    </>
  );
}
